import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  [ORDER_METHODS.delivery]: 'Dostawa',
  [ORDER_METHODS.pickup]: 'Odbiór',
  [ORDER_METHODS.on_site]: 'Zamawianie przy stoliku',
};
